if(typeof app === 'undefined') var app = {};


app.revealTabs = (function(){

    function init() {

        var searchRefinerBtn = $('[data-show-search-filters-btn]');
        var refinerTabsWrapper = $('[data-refiner-tabs]');

        searchRefinerBtn.click(function(e){
            searchRefinerBtn.toggleClass('active');
            refinerTabsWrapper.toggle();
        });

    }

    return {
        'init': init
    };

})();





$(function(){
    app.revealTabs.init();
});